



























































































































































import { graphql } from 'graphql'
import Vue from 'vue'
import {
  SuicideCalls,
  AllCoordinators,
  InsertSuicideCallMutation,
  UpdateSuicideCallMutation,
} from '@/queries/cases.graphql'
import DatePicker from '@/components/workflow/Datepicker.vue'

import { CaseSuicideCall, CaseSuicideCallInput } from '@/graphql-schema'
export default Vue.extend({
  components: {
    DatePicker,
  },
  mounted() {
    this.postData.userIdCaller = this.$store.getters.currentUser?.id
  },
  props: {
    caseId: {
      type: String,
      required: true,
    },
    ascDate: {
      required: false,
      default: null,
    },
  },
  apollo: {
    allCaseSuicideCalls: {
      query: SuicideCalls,
      variables() {
        return {
          caseId: this.caseId,
        }
      },
    },
    allCoordinatorUsers: {
      query: AllCoordinators,
    },
  },
  data(): {
    postData: CaseSuicideCallInput
    formLabel: string
  } {
    return {
      postData: {
        callDate: '',
        followUpDate: null,
        caseId: this.caseId,
        suicideScore: null,
        id: undefined as string,
        patientReached: false,
        riskOfSuicide: '',
        coordinatorContactDate: null,
      } as CaseSuicideCallInput,
      formLabel: 'New emergency call',
    }
  },
  computed: {
    tableIsNotEmpty(): boolean {
      return (
        this.allCaseSuicideCalls != null &&
        this.allCaseSuicideCalls.nodes != null &&
        this.allCaseSuicideCalls.nodes.length > 0
      )
    },
    riskIsOthers(): boolean {
      if (
        this.postData.riskOfSuicide != 'none' &&
        this.postData.riskOfSuicide != 'low' &&
        this.postData.riskOfSuicide != 'medium' &&
        this.postData.riskOfSuicide != 'moderate' &&
        this.postData.riskOfSuicide != 'high' &&
        this.postData.riskOfSuicide != 'critical'
      ) {
        return true
      }
      return false
    },
  },
  methods: {
    saveSuicideCall() {
      //date should be filled
      if (this.postData.callDate == null || this.postData.callDate == '') {
        window.alert('"Date of call" is required ')
        return
      }

      //check, if the id is null. If yes, we should do an insert
      if (this.postData.id == null) {
        this.$apollo
          .mutate({
            mutation: InsertSuicideCallMutation,
            variables: {
              patch: this.postData,
            },
            refetchQueries: [
              {
                query: SuicideCalls,
                variables: { caseId: this.caseId },
              },
            ],
          })
          .then(() => {
            this.newSuicideCall()
          })
      }
      //else we should do an update
      else {
        this.$apollo
          .mutate({
            mutation: UpdateSuicideCallMutation,
            variables: {
              id: this.postData.id,
              patch: this.postData,
            },
          })
          .then(() => {
            this.newSuicideCall()
          })
      }

      //this.$apollo.queries.allCaseSuicideCalls.refetch()
    },
    newSuicideCall() {
      this.postData = {
        callDate: '',
        followUpDate: '',
        id: undefined,
        caseId: this.caseId,
        suicideScore: null,
        patientReached: false,
        riskOfSuicide: '',
        coordinatorContactDate: '',
        userIdCaller: this.$store.getters.currentUser?.id,
      }
      this.formLabel = 'New emergency call'
    },
    isActive(node: CaseSuicideCall) {
      return this.postData.id === node.id
    },
    editSuicideCall(item: CaseSuicideCall) {
      this.postData = item
      delete this.postData.__typename
      delete this.postData.userByUserIdCaller
      this.formLabel = 'Edit emergency call'
    },
  },
})
